import React, { useState, useEffect, useReducer } from "react"
import axios from "axios"
import { useTranslation } from "react-i18next"

import { dataFetchReducer } from "../../../Utils/requestUtils"
import { checkNested } from "../../utils/utils"
import ValidatedImage from "../../utils/ValidatedImage"
import SelfiesDialog from "../../RegistrationDataValidation/ClientProfile/SelfiesDialog"

function ClientProfile(props) {
    const { t } = useTranslation()

    const [selfiesShowDialog, setShowSelfiesDialog] = useState(false)
    const [challengeImagekeys, dispatchChallengeImagekeys] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )
    const [baseRegistrationImage, dispatchBaseRegistrationImage] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const companyKey = props.event?.company_key
    const faceRegistrationKey = props.event?.event_data?.face?.registration_key
    const documentNumber = props.event?.event_data?.document_number

    useEffect(() => {
        if (faceRegistrationKey) {
            dispatchChallengeImagekeys({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get(`/dash/face_recognition/registration/${faceRegistrationKey}/challenge_images?company_key=${companyKey}`)
                    .then(response => dispatchChallengeImagekeys({ type: "data_fetch_success", payload: response.data?.challenge_images }))
                    .catch(error => {
                        if ((error.response || {}).status === 403) dispatchChallengeImagekeys({ type: "data_fetch_failure_403" })
                        else if ((error.response || {}).status === 404) dispatchChallengeImagekeys({ type: "data_fetch_failure_404" })
                        else dispatchChallengeImagekeys({ type: "data_fetch_failure" })
                    })
            }, 500)
            return () => clearTimeout(timer)
        }
    }, [faceRegistrationKey, companyKey])

    useEffect(() => {
        if (documentNumber) {
            dispatchBaseRegistrationImage({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get(`/dash/face_recognition/registration/document_number/${documentNumber}`)
                    .then(response => dispatchBaseRegistrationImage({ type: "data_fetch_success", payload: response.data }))
                    .catch(error => {
                        if ((error.response || {}).status === 403) dispatchBaseRegistrationImage({ type: "data_fetch_failure_403" })
                        else if ((error.response || {}).status === 404) dispatchBaseRegistrationImage({ type: "data_fetch_failure_404" })
                        else dispatchBaseRegistrationImage({ type: "data_fetch_failure" })
                    })
            }, 500)
            return () => clearTimeout(timer)
        }
    }, [documentNumber])

    return (
        <div className="analysisCard" style={{ height: "100%" }}>
            <div style={{ marginBottom: 12 }} className={["blueText", "subtitleSize"].join(" ")}>
                {t("onboarding_data")}
                {documentNumber ? ` - CPF: ${documentNumber}` : ""}
            </div>
            {checkNested(props.event, "event_data", "face", "registration_key") &&
                <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: 24, alignItems: "stretch", gap: 16 }}>
                    {baseRegistrationImage?.fetchedData?.image?.image_key &&
                        <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }} className={["blueText", "textSize"].join(" ")}>
                                {t("registration_selfie")}
                            </div>
                            <ValidatedImage
                                image_key={baseRegistrationImage.fetchedData.image.image_key}
                                dash_api_endpoint_url="/dash/face_recognition/image"
                                imageStyle={{ margin: "auto", maxWidth: "100%", maxHeight: "100%", borderRadius: "5px", objectFit: "contain" }}
                                imageAlt="registration selfie"
                            />
                        </div>
                    }
                    <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }} className={["blueText", "textSize"].join(" ")}>
                            {t("validation_selfie")}
                        </div>
                        <ValidatedImage
                            image_key={faceRegistrationKey}
                            dash_api_endpoint_url="/dash/face_recognition/image"
                            imageStyle={{ margin: "auto", maxWidth: "100%", maxHeight: "100%", borderRadius: "5px", objectFit: "contain" }}
                            imageAlt="validation selfie"
                        />
                        {(challengeImagekeys.fetchedData || []).length > 0 &&
                            <div
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8, marginTop: 20 }}
                                className={["blueText", "textSize", "link"].join(" ")}
                                onClick={() => setShowSelfiesDialog(true)}
                            >
                                {t("see_other_selfies")}
                            </div>
                        }
                    </div>
                </div>
            }
            <SelfiesDialog onClose={() => setShowSelfiesDialog(false)} open={selfiesShowDialog} image_list={challengeImagekeys.fetchedData || []} />
        </div>
    )
}

export default ClientProfile
